import React from "react";

export default function Roadmap() {
  return (
    <div id="roadmap">
      <section className="lg:pb-[100px] py-[50px]">
        <div className="container lg:px-10 px-4">
          <div className="lg:mb-[80px] max-w-[1000px] mx-auto lg:px-10 px-4">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              Protocol Roadmap
            </h3>
          </div>
          <div className="flex justify-center">
            <img src="/assets/arthur-roadmap.svg" />
          </div>
        </div>
      </section>
    </div>
  );
}
